import { render, staticRenderFns } from "./paginationPrevIcon.vue?vue&type=template&id=129c6b06&"
import script from "./paginationPrevIcon.vue?vue&type=script&lang=js&"
export * from "./paginationPrevIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports